export default function getTextFromEl(el, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      lowerCase = _options.lowerCase;
  return el && el.props && el.props.children ? (el.props.children.reduce ? el.props.children : [el.props.children]).reduce(function (acc, child) {
    if (child && child.props && child.props.children) {
      acc += getTextFromEl(child);
    } else if (typeof child === "string") {
      if (lowerCase) {
        acc += child.toLowerCase();
      } else {
        acc += child;
      }
    } else if (typeof child === "number") {
      acc += child + "";
    }

    return acc;
  }, "") : "";
}